<template>
<v-container grid-list-md>
  <bread-crump-partial header="Software Beratung"></bread-crump-partial>
  <v-layout row wrap>
    <v-flex xs12 sm8 md8>
       <p>
            <strong>
                Softwareprojekte bestehen oft aus einer Vielzahl von sehr unterschiedlichen Komponenten. In unserem Bereich sind das in der Regel:
            </strong>
        </p>
        <p>
            Für viele Unternehmen ist eine maßgeschneiderte Softwareentwicklung die beste Option. Statt mehrerer suboptimaler Lösungen und ihrer unüberschaubaren Folgekosten
            schaffen Sie so exakt die Software an, die Sie und Ihre Mitarbeiter brauchen.
        </p>

        <br />
        <accordion :panels="panelTechItems">Technische Aspekte:</accordion>
        <v-spacer class="pb-4"></v-spacer>

        <accordion :panels="panelPlanItems">Planerische Aspekte:</accordion>
    </v-flex>
     <v-flex xs12 sm4 md4>
          <contact-widget></contact-widget>
        </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import BreadCrumpPartial from './partials/BreadCrumpPartial'
import Accordion from './widgets/AccordionWidget'
import ContactWidget from './widgets/ContactWidget'

export default {
  name: 'SolutionsPage',
  components: {
    BreadCrumpPartial,
    Accordion,
    ContactWidget
  },
  data () {
    return {
      name: 'ConsultingPage',
      panelTechItems: [{
        icon: 'local_offer',
        color: 'green',
        title: 'Userinterface (Useability)',
        text: 'Wir legen grossen Wert auf die unbedingte Benutzerfreundlichkeit und der damit verbunden Ergonomie unserer Softwareprodukte. Ziel ist es möglichst jedem User eine 100%ige Nutzung der angebotenen Funktionen zu ermöglichen.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Backend (Datenbank, Cloud)',
        text: 'Das eingentliche Herzstück jeder nachhaltinger Softwarelösung. Wobei hier weniger die technische Ausführung als die Richtige sprich zu der Kondenanforderung passende Architektur ausgewählt wird.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Server (Netzwerk, Skalierbarkeit)',
        text: 'Spielt eigentlich nur noch bei Inhouse-Hosting eine grosse Rolle. Bei Cloudhosting ist die Skalierbeit und Vernnetzung als Teil der Lösung schon vorhanden.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Monitoring',
        text: 'Gerade bei verteilten Lösungen ist ein detailiertes Monitoring und Loggin für einen sicheren Betrieb der Soft- und Hardware unabdingbar.'
      }
      ],
      panelPlanItems: [{
        icon: 'local_offer',
        color: 'green',
        title: 'Konzept',
        text: 'Als Projektvorbereitung wird zunächst eine Systemanalyse durchgeführt, wo zusammen mit dem Kunden die inhaltliche Erfassung der Anforderungen erfolgt. Nach der Untersuchung weiterer sachlicher und technischen Anforderungen und Randbedingen wie Schnittellen entsteht dann als Ergebniss ein Fachkonzept.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Workflow',
        text: 'Die genaue Definition und Bescheibung der praktizierten Workflows hat aus unser Erfahrung eine entscheiden Einfluss auf die Umsetzungeschwindigkeit der geplanten Projekte.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Projektierung',
        text: 'Selbst bei kleinenren Projekten setzen wir durchgehend auf den Einsatz von agilen Projektmanagmentprozessen. Diese haben sich auf beiden Seiten vielfach bewährt.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Dokumentation',
        text: 'Eine gute und ausfühliche (technische) Dokumentation gehört zu unseren Minimumstandards bei der Entwicklung von Softwareprojekten.'
      },
      {
        icon: 'local_offer',
        color: 'green',
        title: 'Datensicherheit',
        text: 'Die Berücksichtung von von Datensicherheitsrelaventen Aspketen gleich zur Anfang der Projektentwicklung zählt ebenfalls zu unseren Standards.'
      }
      ]

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ConsultingPage.vue